import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../Components/Sidebar";
import "./PracticeResult.css";

const PracticeResult = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const [details, setDetails] = useState({});
  const lang = localStorage.getItem("lang") || "en";

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/practice_result`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
            },
          }
        );
        setResult(res.data.data);
      } catch (error) {
        console.error("Failed to load practice result", error);
      } finally {
        setLoading(false);
      }
    };
    fetchResult();
  }, []);

  const toggleQuestion = async (q) => {
    if (expanded === q.question_id) {
      setExpanded(null);
      return;
    }

    if (!details[q.question_id]) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/practice_result_details`,
          {
            practice_id: result.practice_id,
            question_id: q.question_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
            },
          }
        );
        setDetails((prev) => ({
          ...prev,
          [q.question_id]: res.data.data,
        }));
      } catch (error) {
        console.error("Failed to fetch detail", error);
      }
    }
    setExpanded(q.question_id);
  };

  if (loading)
    return (
      <div className="pr-loading">
        <Sidebar />
        <div className="pr-main">Loading...</div>
      </div>
    );

  if (!result)
    return (
      <div className="pr-empty">
        <Sidebar />
        <div className="pr-main">No practice result found.</div>
      </div>
    );

  return (
    <div className="overview">
      <Sidebar />
      <div className="pr-wrapper">
        <div className="pr-summary-card">
          <h2 className="pr-title">Your Practice Summary</h2>
          <div className="pr-score-circle">
            <svg viewBox="0 0 36 36" className="pr-progress-ring">
              <path
                className="pr-ring-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                className="pr-ring-progress"
                strokeDasharray={`${(result.score_percent * 100).toFixed(
                  0
                )}, 100`}
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="pr-ring-text">
                {(result.score_percent * 100).toFixed(0)}%
              </text>
            </svg>
          </div>

          <div className="pr-summary-stats">
            <div className="pr-summary-item">
              <span>Total Attempted</span>
              <strong>{result.total_attempted}</strong>
            </div>
            <div className="pr-summary-item">
              <span>Correct</span>
              <strong>{result.correct}</strong>
            </div>
          </div>
        </div>

        <div className="pr-question-list">
          <h3 className="pr-subtitle">Question Details</h3>
          {result.questions.map((q, index) => (
            <div
              key={q.question_id}
              className={`pr-question-item ${
                q.answered_correct ? "pr-correct" : "pr-wrong"
              } ${expanded === q.question_id ? "pr-expanded" : ""}`}
            >
              <div
                className="pr-question-header"
                onClick={() => toggleQuestion(q)}
              >
                <div className="pr-qindex">{index + 1}.</div>
                <div className="pr-qtext">
                  {lang === "bn" ? q.question_text_bangla : q.question_text}
                </div>
                <div className="pr-toggle-icon">
                  {expanded === q.question_id ? "▲" : "▼"}
                </div>
              </div>

              {expanded === q.question_id && details[q.question_id] && (
                <div className="pr-question-body">
                  <div className="pr-detail-section">
                    {details[q.question_id].image &&
                      (details[q.question_id].image.match(
                        /\.(mp4|webm|ogg)$/i
                      ) ? (
                        <video
                          src={details[q.question_id].image}
                          className="pr-qimage"
                          controls
                        />
                      ) : (
                        <img
                          src={details[q.question_id].image}
                          alt="question"
                          className="pr-qimage"
                        />
                      ))}

                    <div className="pr-answers">
                      <p>
                        <strong>Your Answer:</strong>{" "}
                        <span
                          className={
                            details[q.question_id].is_correct
                              ? "pr-correct-text"
                              : "pr-wrong-text"
                          }
                        >
                          {lang === "bn"
                            ? details[q.question_id].user_answer_bangla
                            : details[q.question_id].user_answer}
                        </span>
                      </p>
                      <p>
                        <strong>Correct Answer:</strong>{" "}
                        <span className="pr-correct-text">
                          {lang === "bn"
                            ? details[q.question_id].correct_answer_bangla
                            : details[q.question_id].correct_answer}
                        </span>
                      </p>
                      <div className="pr-explanation">
                        <strong>Explanation:</strong>{" "}
                        {lang === "bn"
                          ? details[q.question_id].explanation_bangla
                          : details[q.question_id].explanation}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PracticeResult;
